import { type ReactNode, type JSX } from 'react';
import urlRegexSafe from 'url-regex-safe';

import { ExternalLink } from '../../typography/external-link/ExternalLink.js';

// the regex to be used to detect URLs
const regex = urlRegexSafe({ strict: true });

export const replaceUrlsWithLinks = (text: string): string | JSX.Element => {
  const matches: { url: string; startIndex: number; endIndex: number }[] = [];
  let match = regex.exec(text);

  // Find all matches and their positions
  while (match !== null) {
    matches.push({
      url: match[0],
      startIndex: match.index,
      endIndex: regex.lastIndex,
    });
    match = regex.exec(text);
  }

  // If there are no matches, return the original text
  if (matches.length === 0) {
    return text;
  }

  const result: ReactNode[] = [];
  let currentIndex = 0;

  matches.forEach((match, index) => {
    // Add the text before the URL
    if (match.startIndex > currentIndex) {
      result.push(text.substring(currentIndex, match.startIndex));
    }

    // Add the URL as a custom link component
    result.push(
      <ExternalLink key={index} href={match.url}>
        {match.url}
      </ExternalLink>,
    );

    // Update the current index to be after the inserted url/link
    currentIndex = match.endIndex;
  });

  // Add any remaining text after the last match
  if (currentIndex < text.length) {
    result.push(text.substring(currentIndex));
  }

  return <span>{result}</span>;
};
